var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0119 16C32.0053 7.16348 24.8365 0.00535742 16 0.0119204C7.16344 0.0184834 0.00532034 7.18725 0.0118833 16.0238C0.0184463 24.8604 7.18721 32.0185 16.0238 32.0119C24.8603 32.0053 32.0184 24.8366 32.0119 16Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5411 23.9959L7.55806 24L11.0517 20.5081L14.5411 23.9959Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.331 15.8897L23.4426 23.9956H15.6611L7.55095 15.8897H15.331Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8911 7C20.3691 7.20515 23.9426 10.872 23.9988 15.3855L23.9995 15.4936C23.9995 15.4989 23.9998 15.5042 24 15.5094C23.996 17.7097 23.1587 19.7114 21.7842 21.2187L15.8911 15.3294V7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.099 15.0976H7C7.20087 10.7171 10.7172 7.20095 15.099 7.00017V15.0976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolv);
export default __webpack_public_path__ + "static/media/RESOLV.a328b2f96240001bf5d0d3a6ef7ebfa1.svg";
export { ForwardRef as ReactComponent };